<template>
    <div class="color-picker">
        <BaseColorPicker
            :value="value"
            :size="size"
            v-bind="$attrs"
            v-on="listeners"
            @input="onChange"
        />
    </div>
</template>
<script setup lang="ts">
import { useListeners } from 'vue'
import BaseColorPicker from '@/components/RedesignBaseComponents/Form/BaseColorPicker.vue'

const listeners = useListeners()

withDefaults(
    defineProps<{ value: string, size?: 'medium' | 'small' | 'mini' }>(),
    {
        size: 'mini',
        value: '#FFFFFF'
    }
)

const emit = defineEmits([ 'input' ])

function onChange (val: string) {
    emit('input', val)
}
</script>
